<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">T<span class="small">ABLE</span> <span class="small">OF</span> C<span class="small">ONTENTS</span> &amp; M<span class="small">AP</span> K<span class="small">EY</span></p>
<table>
<colgroup>
<col width="70px"/>
<col width="320px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Int">Introduction</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Chapter 1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Fishing with Your Feet in the Sand!</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Chapter 2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Swimmers, Surfers, and the Sharks They Meet</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Chapter 3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">1916: Shark Terror on the Shore</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Chapter 4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Have You Ever Seen a Flying Shark?</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Chapter 5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Who Said You Can’t Catch a Shark with a Net?</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Chapter 6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">When Sharks Attack Boats!</span></td></tr>
<tr><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Chapter 7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Sharks Onboard: Not Well-Behaved Passengers</span></td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Chapter 8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Odd &amp; Curious Shark Encounters Along the Shore</span></td></tr>
<tr><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Chapter 9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Sharks: The Big Fish with the Bad Reputation</span></td></tr>
<tr><td colspan="2"><span href="#/Before_go#Bef" title="Link target outside of Sample">Before You Go: Lifeguard-Approved Safety Tips</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?15bc672c